import React, {Component,Fragment} from "react";
import './index.less'
import EventBus from '///utils/eventBus'
let timer = null
export default class PortalContentTag extends Component{
    constructor(props) {
        super(props)
        this.state = {
            tags:[
                // {key:"contents1", anchor:'portalIntroduction', title:"平台介绍",},
                {key:"contents2", anchor:'portalFun', title:"平台功能",},
                {key:"contents3", anchor:'portalCharacter', title:"平台特色",},
                {key:"contents4", anchor:'portalScene', title:"应用场景",},
                {key:"contents5", anchor:'portalProduction', title:"应用产品",},
                // {key:"contents6", anchor:'portalRecommend', title:"相关推荐",},
            ],
            scrollTopLimit:365,
            contentTagFixFlag:false,
            currentContentAnchor:'portalFun',
        }
    }
    render() {
        let { tags, contentTagFixFlag , currentContentAnchor } = this.state
        let { handleTagClick } = this
        return (
            <Fragment>
                <div className={`portal-content-tag ${contentTagFixFlag ? 'portal-content-tag-fixed' : null}`}>
                    <ul className={'w1200'}>
                        {tags.map(ele => {
                            return (
                                <li onClick={() => {handleTagClick(ele.anchor)}} className={`${currentContentAnchor === ele.anchor ? 'selected' : null}`} key={ele.key}>
                                    <a href={ '#' + ele.anchor}>{ele.title}</a>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </Fragment>

        )
    }

    componentDidMount() {
        this.bindScroll()
        this.bindHashChange()
    }

    bindSendData = (contentTagFixFlag) => {
        EventBus.emit('content-tag-fix-flag',{contentTagFixFlag:contentTagFixFlag})
    }

    bindScroll = () => {
        let _this = this
        window.onscroll = () => {
            let currentAnchor = null
            for (let i = 0; i < _this.state.tags.length; i++) {
                if(this.elementInView(document.getElementById(this.state.tags[i].anchor))){
                    currentAnchor = _this.state.tags[i].anchor
                    break;
                }
            }
            _this.setState({
                contentTagFixFlag : _this.scroll().top >= this.state.scrollTopLimit,
                currentContentAnchor:currentAnchor || 'portalFun'
            },() => {
                this.bindSendData(this.state.contentTagFixFlag)
            })
        }
    }

    handleTagClick = (anchor) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            this.setState({currentContentAnchor:anchor})
            clearTimeout(timer)
        },1)
    }

    bindHashChange = () => {
        window.onhashchange = () => {
            let hashVal = window.location.hash.substring(1)
            if(hashVal){
                this.setState({currentContentAnchor:hashVal})
            }
        }
    }

    elementInView = (element) => {
        const rect = element.getBoundingClientRect()
        const yInView = rect.top < window.innerHeight && rect.bottom > 0
        const xInView = rect.left < window.innerWidth && rect.right > 0
        return yInView && xInView
    }

    scroll = () => {
        return {
            top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0,
            left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0
        }
    }

    componentWillUnmount() {
        window.onscroll = null
        window.onhashchange = null
        clearTimeout(timer)
    }

}